var defaultBranding = {
    uuid: "uuid",
    businessId: "busiensId",
    teamId: "teamId",
    businessLogoUrl: "https://res.cloudinary.com/perkbox/image/upload/v1524747023/2811db0a-3811-42d0-804b-ab74e73f00bb.png",
    businessSquareLogoUrl: "",
    isEnabled: true,
    primaryColour: "#00adef",
    textColour: "#000"
};
export default defaultBranding;
